import React from 'react';
import { Collapse, Radio, Select } from 'antd';
import GroupSlider from 'antd-group-slider';
import { t } from '../../../i18n/i18n';
import CountryFlag from '../../CountryFlag/CountryFlag';
import GenericToggle from '../../GenericToggle/GenericToggle';

const { Option } = Select;
const { Panel } = Collapse;
export const TestGroupLanguage = ({
  testGroupData,
  languagesList,
  handleSelectLanguageOption,
  selectedLang,
  key,
  setSelectedLang,
  handleSelectObjetivesOption,
  handleModifyLangData,
  handleSelectTestFormats,
  testFormats,
  toggleScoreTags,
  setToggleScoreTags,
  groupSliderInitialData,
  handleScoreTags,
  readOnly = false,
}) => (
  <>
    <div className="my-2 col-flex">
      <span className="row mx-3 font-weight-bold text-base my-2">
        {t('CREATE_TEST_GROUP_LANGUAGES_TITLE')}
      </span>
      <span className="row mx-2 font-weight-300 text-s my-1">
        {t(
          readOnly
            ? 'Ingrese el detalle en el lenguaje seleccionado a traducir'
            : 'El primer lenguaje seleccionado sera el lenguaje por defecto en el que debera cargar los test, luego debera crear las traducciones correspondientes'
        )}
      </span>
      <Select
        mode="multiple"
        style={{
          width: '100%',
        }}
        className=""
        placeholder={t('CREATE_TEST_GROUP_LANGUAGES_PLACEHOLDER')}
        onChange={(value) => {
          if (!value || value === '') return handleSelectLanguageOption([]);
          const langs = String(value).split(',');
          handleSelectLanguageOption(langs);
        }}
        value={testGroupData?.languages}
        popupClassName=""
        disabled={readOnly}
      >
        {languagesList.map((x) => (
          <Option value={x.value}>
            <CountryFlag countryIso={x.iso} size="sm" className="mr-2" />
            {t(x.label)}
          </Option>
        ))}
      </Select>
    </div>
    <div className="w-100 border-thin-blue-principal p-4 my-2">
      <div className="d-flex justify-content-between w-100">
        <Radio.Group value={selectedLang ?? key} onChange={(e) => setSelectedLang(e.target.value)}>
          {testGroupData?.languages?.map((lang) => (
            <Radio.Button value={lang}>
              <CountryFlag
                countryIso={languagesList?.find((y) => y.value === lang)?.iso}
                size="sm"
              />
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>

      <div className="">
        <div className="d-flex justify-content-between">
          <span className=" font-weight-bold text-base my-1">
            {t('CREATE_TEST_GROUP_OBJETIVES_TITLE')}
          </span>
        </div>

        <Select
          mode="tags"
          style={{
            width: '100%',
          }}
          placeholder={t('CREATE_TEST_GROUP_OBJETIVES_PLACEHOLDER')}
          onChange={(value) => {
            if (!value || value === '' || value?.length === 0) {
              return handleSelectObjetivesOption(selectedLang, []);
            }
            const objs = String(value).split(',');
            handleSelectObjetivesOption(selectedLang, objs);
          }}
          value={
            testGroupData?.objetives
              ? selectedLang
                ? testGroupData?.objetives[selectedLang] ?? []
                : testGroupData?.objetives[key]
              : []
          }
          disabled={!testGroupData?.languages || !testGroupData?.languages?.length || readOnly}
        >
          {testGroupData.objetives
            ? selectedLang
              ? (testGroupData?.objetives[selectedLang] ?? []).map((tag) => (
                  <Option value={tag}>{tag}</Option>
                )) ?? null
              : (testGroupData?.objetives[key] ?? []).map((tag) => (
                  <Option value={tag}>{tag}</Option>
                ))
            : null}
        </Select>
      </div>
      <div className="d-flex my-3 flex-column w-100 mr-5">
        <span className=" font-weight-bold text-base my-1">
          {t('CREATE_TEST_GROUP_NAME_TITLE')}
        </span>
        <input
          name="nameTranslated"
          type="text"
          className={`border-thin-blue-principal outline-none w-100 p-2 text-xs ${
            testGroupData?.nameTranslated?.[selectedLang]?.length ? 'selected-border' : 'unselected-border'
          }`}
          placeholder={t('CREATE_TEST_GROUP_NAME_PLACEHOLDER')}
          onChange={(e) => handleModifyLangData(selectedLang, e)}
          value={
            testGroupData?.nameTranslated
              ? selectedLang
                ? testGroupData?.nameTranslated[selectedLang] ?? ''
                : testGroupData?.nameTranslated[key] ?? ''
              : ''
          }
          disabled={!testGroupData.languages || !testGroupData.languages?.length || readOnly}
          maxLength={100}
        />
      </div>
      <div className="d-flex my-3 flex-column w-100 mr-5">
        <span className=" font-weight-bold text-base my-1">
          {t('CREATE_TEST_GROUP_DESCRIPTION_TITLE')}
        </span>
        <textarea
          name="summary"
          className={`border-thin-blue-principal outline-none w-100 p-2 text-xs  min-height-textarea-description ${
            testGroupData?.summary?.length ? 'selected-border' : 'unselected-border'
          }`}
          rows="5"
          placeholder={t('CREATE_TEST_GROUP_SUMMARY_PLACEHOLDER')}
          onChange={(e) => handleModifyLangData(selectedLang, e)}
          value={
            testGroupData?.summary
              ? selectedLang
                ? testGroupData?.summary[selectedLang] ?? ''
                : testGroupData?.summary[key]
              : ''
          }
          disabled={!testGroupData.languages || !testGroupData.languages?.length || readOnly}
          maxLength={350}
        />
      </div>
      <div className="d-flex my-3 flex-column w-100 mr-5">
        <span className=" font-weight-bold text-base my-1">
          {t('CREATE_TEST_GROUP_DETAIL_TITLE')}
        </span>
        <textarea
          name="detail"
          className={`border-thin-blue-principal outline-none w-100 p-2 text-xs  min-height-textarea-description ${
            testGroupData?.detail?.length ? 'selected-border' : 'unselected-border'
          }`}
          rows="5"
          placeholder={t('CREATE_TEST_GROUP_DETAIL_PLACEHOLDER')}
          onChange={(e) => handleModifyLangData(selectedLang, e)}
          value={
            testGroupData?.detail
              ? selectedLang
                ? testGroupData?.detail[selectedLang] ?? ''
                : testGroupData?.detail[key]
              : ''
          }
          disabled={!testGroupData?.languages || !testGroupData.languages?.length || readOnly}
          maxLength={550}
        />
      </div>
    </div>
    <div className="my-4">
      <span className=" font-weight-bold text-base my-4">
        {t('CREATE_TEST_GROUP_TEST_FORMATS_TITLE')}
      </span>
      <Select
        mode="multiple"
        style={{
          width: '100%',
        }}
        className=""
        placeholder={t('CREATE_TEST_GROUP_TEST_FORMATS_PLACEHOLDER')}
        onChange={(value) => {
          handleSelectTestFormats(value);
        }}
        value={testGroupData?.testFormatIds}
        disabled={readOnly}
        popupClassName=""
        size="middle"
      >
        {testFormats.map((x) => (
          <Option value={x?.id}>
            <img
              src={x?.iconUrl}
              alt="Format test logo"
              className="text-blue-principal mr-2"
              style={{ width: '1rem', height: '1rem' }}
            />
            {t(x?.label)}
          </Option>
        ))}
      </Select>
    </div>
    <div className="w-100 border-thin-blue-principal p-4 my-2" disabled={readOnly}>
      <Collapse
        activeKey={toggleScoreTags ? '1' : null}
        accordion
        ghost
        onChange={() => {
          setToggleScoreTags(!toggleScoreTags);
        }}
      >
        <Panel
          key="1"
          header={
            <GenericToggle
              leftText={t('CREATE_TEST_SCORE_TAGS_TITLE')}
              leftTextClassName="text-sm  font-weight-bold my-2"
              actionFunction={() => {}}
              actionFunctionValue={setToggleScoreTags}
              value={toggleScoreTags}
            />
          }
          showArrow={false}
        >
          <GroupSlider
            initialValues={groupSliderInitialData}
            descriptionConfig={{
              leftAddonText: `${t('SCORE_TAGS_LABEL_FROM')} {{range}}: `,
              type: 'input',
            }}
            onChange={handleScoreTags}
            addButtonText={t('SCORE_TAGS_ADD_BUTTON_LABEL')}
            removeButtonText={t('SCORE_TAGS_REMOVE_BUTTON_LABEL')}
            showDivider
          />
        </Panel>
      </Collapse>
    </div>
  </>
);
